export class ReportCommissionProcessingAnalysisContractFlag {
	public warning: string;
	public total: number;
	public autoProcessed: number;
	public manuallyProcessed: number;
	public onHold: number;

	constructor(reportCommissionProcessingAnalysisContractFlag: ReportCommissionProcessingAnalysisContractFlag) {
		Object.assign(this, reportCommissionProcessingAnalysisContractFlag);
	}
}
